import * as React from "react";
import { Dialog, DialogContent, DialogTitle, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

import type { FeedbackConfig } from "@/api/feedback";
import { FeedbackForm } from "@/features/feedback/FeedbackForm";
import { useOptionalToast } from "@/hooks/useToast";

export { sessionIdFromPath } from "@/features/feedback/FeedbackForm";

/** "Send feedback": the feedback form in a dialog, with the category
 *  picker. Mounted only while open, so every open starts clean. Where
 *  requests are on, the Ask panel renders the same form instead. */
export function FeedbackDialog(props: {
  config: FeedbackConfig;
  onClose: () => void;
}): React.JSX.Element {
  const { t } = useTranslation();
  const phone = useMediaQuery(useTheme().breakpoints.down("sm"));
  const toast = useOptionalToast();
  return (
    <Dialog open onClose={props.onClose} fullWidth maxWidth="sm" fullScreen={phone}>
      <DialogTitle>{t("feedback.title")}</DialogTitle>
      <DialogContent>
        <FeedbackForm
          config={props.config}
          category={null}
          onSent={() => {
            toast?.(t("feedback.sent"), "success");
            props.onClose();
          }}
          onCancel={props.onClose}
        />
      </DialogContent>
    </Dialog>
  );
}
